import Client from '../HttpClient';

const baseUrl = '/gateway/numbat-api/api/vs/manage-menucloud';

const bind = (merchantId, payload) => {
	return Client.post(`${baseUrl}/${merchantId}/menuBranchRelas`, payload);
};

const find = (merchantId, id) => {
	return Client.get(`${baseUrl}/${merchantId}/menuBranchRelas/${id}`);
};

const remove = (merchantId, id) => {
	return Client.del(`${baseUrl}/${merchantId}/menuBranchRelas/${id}`);
};

const bindings = (merchantId, payload) => {
	return Client.get(
		`${baseUrl}/${merchantId}/menuBranchRelas/bindings`,
		payload
	);
};

export default {
	bind,
	find,
	remove,
	bindings,
};
